import Tier from './Tier/Tier';
import * as actions from '../PASActions';

const Tier1 = ({ dispatch, save, fields }) => {
    return (
        <div>
            <div className="pt-4 pb-4 text-12 text-gray-500">
                Tier 1 resources include enterprise assets like servers, databases and applications. Privileged accounts
                authenticating to resources in this tier, but not to tier 0, will be considered tier 1 accounts.
            </div>
            <Tier dispatch={dispatch} save={save} fields={fields} updateAction={actions.UPDATE_TIER1} />
        </div>
    );
};

export default Tier1;
